<template>
  <div class="jobs-create" v-loading="loading" style="padding-top: 20px">
    <el-form>
      <div style="width: 100%">
      <span class="obj-name" v-if="$route.query.docs_name">
        Выбранный раздел: <strong>{{ ` ` + $route.query.docs_name }}</strong>
      </span>
      </div>
      <div>
        <el-upload
          v-if="uploadValue === null"
          list-type="picture"
          :http-request="onUpload"
          class="upload-demo"
          action="/"
          :show-file-list="false"
          drag
          multiple
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">Перетащите файл сюда или <em>нажмите, чтобы загрузить</em></div>
        </el-upload>
        <el-progress v-else :percentage="uploadValue"></el-progress>
      </div>
      <div
        class="jobs-ul"
      >
        <div class="jobs-li" v-for="(file, index) in files" :key="index">
          <div class="jobs-text">
            <a :href="file.file" target="_blank" v-if="!file.editable">{{ file.name }}</a>
            <el-input type="textarea" v-else v-model="file.name"></el-input>
          </div>
          <span>
          <i class="fa fa-trash" @click="deleteFile(index)" style="margin-right: 28px"></i>
          <i class="fa fa-edit" @click="file.editable = !file.editable"></i>
        </span>
        </div>
      </div>


      <div class="jobs-create__buttons">
        <el-button @click="close">Отмена</el-button>
        <el-button type="primary" @click="save" :disabled="!files.length">Сохранить</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import firebase from 'firebase';
import FilterSelect from '../../../components/FilterSelect';
import work_units from '../../../data/work_units';
import AddObjects from '../Reports/components/AddObjects';
import UnitSelect from '../components/unitSelect';
import {fetchObjectsWithParent} from "../../../firestore/objects";
import {v4 as uuidv4} from "uuid";

export default {
  name: 'Create',
  props: {
    isNested: Boolean,
    obj: String,
    type_prop: String,
  },
  components: {UnitSelect, AddObjects, FilterSelect},
  data() {
    return {
      options_units: work_units,
      loading: false,
      checked: false,
      uploadValue: null,
      object: null,
      files: [],
      form: {
        name: '',
        file: null,
      },
      options_works: [],
    };
  },
  async mounted() {
    if (this.$route.name === 'FilesEdit') {
      firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('files').doc(this.$route.params.id).get().then((data) => {

        const subData = data.data();

        this.form = {
          ...subData,
        };
      });
    }
  },

  methods: {
    deleteFile(i) {
      const files = [...this.files];

      files.splice(i, 1);

      this.files = files;
    },
    onUpload(e) {
      const imageData = e.file;
      const extension = imageData.name.split('.').pop();
      const storageRef = firebase.storage(
      ).ref(`reports/${uuidv4()}.${extension}`).put(imageData);
      storageRef.on(`state_changed`, snapshot => {
          this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        }, error => {
          console.log(error.message);
        },
        () => {
          this.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.files.push({file: url, name: imageData.name, editable: false});
            this.uploadValue = null;
          });
        },
      );
    },
    deleteObject() {
      this.$confirm('Вы действительно хотите удалить?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('files')
          .doc(this.$route.params.id).delete()
          .then((data) => {
            this.$notify({
              offset: 60,
              title: 'Успешно!',
              message: 'удалено',
              type: 'success',
            });
            this.$router.go(-1);
          });
      });
    },
    close() {
      if (!this.isNested) {
        this.$router.go(-1);
      }
      this.$emit('close');
    },

    async save() {
      const jobs_s_r = await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('files')
        .orderBy("index", 'desc').limit(1)
        .get();

      let jobs_s = {
        index: 0
      };

      jobs_s_r.forEach((subDoc) => {
        jobs_s = subDoc.data();
      });

      const promises = [];

      this.files.forEach((file, index) => {
        delete file.editable;
        promises.push(
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('files')
          .add({
            ...file,
            documentation: [this.$route.params.id || 'all'],
            index: jobs_s.index + index + 1,
          }));
      });

      Promise.all(promises).then(() => {
        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'Новыйе документы добавлены',
          type: 'success',
        });
        this.$router.go(-1);
      });
    }
  },
};
</script>

<style scoped lang="scss">
.jobs-create {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 42px auto;

  > > > .el-form-item {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    .el-form-item__content {
      display: flex;
      justify-content: flex-start;
      width: 100%;
    }

    .el-form-item__label {
      padding: 0;
    }
  }

  &__buttons {
    margin-top: 28px;
    justify-content: space-between;
    width: 100%;
    flex: 1;
    display: flex;

    &:before {
    }

    &:after {
    }
  }

  .input-line-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex: 1;
  }

  .select-type {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
}

.obj-name {
  text-align: left;
  margin-bottom: 10px;
  display: flex;
  width: 100%;
  justify-content: flex-start;
}

.link {
  display: flex;
  justify-content: space-between;
  text-align: left;
  flex-direction: column;
}

.jobs-list {
  max-width: 428px;
  width: calc(100% - 40px);
  margin: 22px auto;
  padding-top: 20px;
}

.jobs-text {
  display: flex;
  align-items: center;
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;

  a {
    color: #000;
    text-decoration: none;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
      text-decoration: underline;
    }
  }

  .handle {
    margin-right: 30px;
  }
}

.jobs-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .jobs-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    min-height: 36px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 8px 12px;
    text-align: left;

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Files/Create.vue